import type { LocationQuery } from '#vue-router'

export const queryValueToNumber = (x: LocationQuery[string]): number | null => {
  const strValue = queryValueToString(x)
  if (strValue === null) {
    return null
  }
  return parseFloat(strValue)
}
